export default "__VITE_ASSET__a7ec6553__"